import * as yup from "yup";

import { RewardType } from "@/api/modules/daily-login-reward";

const rewardSchema = yup.lazy((value, context) => {
  if (value && typeof value === "object" && Object.keys(value).length === 0) {
    value = undefined;
  }

  const rewardType = context.parent.rewardType;
  switch (rewardType) {
    case RewardType.Credit:
      return yup
        .object({
          amount: yup.number().min(1).required().default(0),
        })
        .required();
    case RewardType.FortuneWheel:
      return yup
        .object({
          spins: yup.number().min(1).required().default(0),
        })
        .required();
    case RewardType.BonusBoost:
      return yup
        .object({
          bonusBoost: yup.number().min(1).required().default(0),
          depositCount: yup.number().min(1).required().default(0),
          maxDepositPeriod: yup.number().nullable().default(null),
        })
        .required();
    default:
      return yup
        .object({
          amount: yup.number().required(),
        })
        .required();
  }
});

const sequenceSettingsSchema = yup.object({
  isActive: yup.boolean().defined(),
  sequence: yup.number().integer().min(1).max(10).required(),
  rewardType: yup
    .mixed<RewardType>()
    .oneOf(Object.values(RewardType))
    .required(),
  reward: rewardSchema,
});

export function useDailyLoginRewardsFormSchema() {
  return yup.object({
    isActive: yup.boolean().defined(),
    cooldown: yup.number().required(),
    sequenceSettings: yup
      .object({
        "0": yup.array(sequenceSettingsSchema),
        "1": yup.array(sequenceSettingsSchema),
        "2": yup.array(sequenceSettingsSchema),
        "3": yup.array(sequenceSettingsSchema),
        "4": yup.array(sequenceSettingsSchema),
        "5": yup.array(sequenceSettingsSchema),
      })
      .required(),
  });
}

export type DailyLoginRewardsFormSchema = yup.InferType<
  ReturnType<typeof useDailyLoginRewardsFormSchema>
>;
